import Utils from 'services/utils';
import Config from 'services/config/local';
import Customer from './customer.class';

// noinspection JSUnresolvedVariable,Eslint
if (!ENVIRONMENT || ['development', 'test'].indexOf(ENVIRONMENT)) {
    require('./customer.json'); // eslint-disable-line global-require
    require('./customers.json'); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    const data = response.data;

    if ('customers' in data) {
        data.customers = data.customers.map(customer => new Customer(customer));
    }

    return data;
}

/**
 * CustomersApi class.
 */
export default class CustomersApi {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    constructor($http) {
        this.$http = $http;
        this.config = Config.api.customers;
    }

    /**
     * Get Customers
     * @returns {promise}
     */
    getList() {
        return this.$http.get(this.config.listUrl).then(responseDataExtractor);
    }

    /**
     * Search Customers by query
     * @param {string} query - Search pattern
     * @param {Object} metadata - Request settings, like: limit, ofset etc.
     * @returns {promise}
     */
    search(query, metadata = {}) {
        return this.$http.get(
            this.config.searchUrl,
            {
                params: {
                    query: `${query}*`,
                    ...metadata
                }
            })
            .then(responseDataExtractor);
    }

    /**
     * Get Customer by customer id
     * @param {number} customerId - Customer id
     * @returns {promise}
     */
    getCustomer(customerId) {
        const url = Utils.formatString({ customerId }, this.config.getUrl);

        return this.$http.get(url).then(responseDataExtractor);
    }

    /**
     * Activate Customer by customer id
     * @param {number} customerId - Customer id
     * @returns {promise}
     */
    activateCustomer(customerId) {
        const url = Utils.formatString({ customerId }, this.config.activateUrl);

        return this.$http.post(url).then(responseDataExtractor);
    }

    /**
     * Deactivate Customer by customer id
     * @param {number} customerId - Customer id
     * @returns {promise}
     */
    deactivateCustomer(customerId) {
        const url = Utils.formatString({ customerId }, this.config.deactivateUrl);

        return this.$http.post(url).then(responseDataExtractor);
    }

    /**
     * Request access to view Customer info
     * @param {{customer_id: string, message: string}} request - Request body
     * @returns {promise}
     */
    requestAccessToCustomer(request) {
        const url = Utils.formatString({ customerId: request.customer_id }, this.config.requestAccessUrl);

        return this.$http.post(url, { ...request }).then(responseDataExtractor);
    }

    /**
     * Reset Customer password by customer id
     * @param {number} customerId - Customer id
     * @returns {promise}
     */
    resetPasswordForCustomer(customerId) {
        const url = Utils.formatString({ customerId }, this.config.resetPasswordUrl);

        return this.$http.post(url).then(responseDataExtractor);
    }

}



// WEBPACK FOOTER //
// ./app/services/api/customers/customers.service.js